import {
  FormControlLabel,
  Grid,
  MenuItem,
  Switch,
  TextField,
} from "@mui/material";
import { NumericFormat } from "react-number-format";

const TabDetails = ({
  produto,
  erros,
  optionsCurrency,
  grupos,
  locaisNotificacoes,
  handleChange,
  handleChecked,
}) => {
  return (
    <Grid container spacing={2} alignItems="center">
      <Grid
        size={{
          xs: 12,
          sm: 6
        }}>
        <TextField
          variant="outlined"
          label={"Nome"}
          name="nome"
          required
          inputProps={{ maxLength: 60 }}
          fullWidth
          error={erros.nomeProduto}
          helperText={erros.nomeProduto}
          placeholder="Máximo de 35 caracteres"
          value={produto.nome || ""}
          onChange={(event) => handleChange(event)}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 4
        }}>
        <TextField
          variant="outlined"
          select
          required
          fullWidth
          label={"Categoria"}
          name="grupoProduto.id"
          value={produto?.grupoProduto?.id || ""}
          onChange={(event) => handleChange(event)}
        >
          {grupos.map((grupo) => (
            <MenuItem key={grupo.id} value={grupo.id}>
              {grupo.descricao}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid
        size={{
          xs: 6,
          sm: 2
        }}>
        <NumericFormat
          customInput={TextField}
          label="Preço"
          variant="outlined"
          fullWidth
          value={produto.preco}
          thousandSeparator="."
          decimalSeparator=","
          decimalScale={optionsCurrency.decimalPlaces}
          fixedDecimalScale
          prefix={optionsCurrency.currencySymbol}
          required
          name="preco"
          onValueChange={(values) =>
            handleChange({
              target: {
                name: "preco",
                value: values.value,
              },
            })
          }
        />
      </Grid>
      <Grid
        size={{
          xs: 6,
          sm: 3
        }}>
        <TextField
          variant="outlined"
          select
          fullWidth
          required
          label={"Local Impressão"}
          name="localImpressao"
          error={erros.localImpressao}
          value={produto.localImpressao || ""}
          helperText={
            locaisNotificacoes.length === 0
              ? "carregando...."
              : erros.localImpressao
          }
          onChange={(event) => handleChange(event)}
        >
          {locaisNotificacoes.length === 0 ? (
            <span>carregando...</span>
          ) : (
            locaisNotificacoes.map((local) =>
              local.chave !== "DELIVERY" ? (
                <MenuItem key={local.id} value={local.chave}>
                  {local.descricao}
                </MenuItem>
              ) : null
            )
          )}
        </TextField>
      </Grid>
      <Grid
        size={{
          xs: 6,
          sm: 2
        }}>
        <FormControlLabel
          name="promocaoAtiva"
          fullwidth="true"
          control={
            <Switch
              checked={produto.promocaoAtiva}
              color="primary"
              name="promocaoAtiva"
              onChange={(event) => handleChecked(event)}
            />
          }
          label={"Promoção"}
        />
      </Grid>
      <Grid
        size={{
          xs: 6,
          sm: 3
        }}>
        <TextField
          select
          name="localVenda"
          fullWidth
          label="Mostrar"
          onChange={(event) => handleChange(event)}
          value={produto.localVenda || ""}
          variant="outlined"
        >
          <MenuItem value="TODOS">Sempre visível</MenuItem>

          <MenuItem label="Delivery" value={"DELIVERY"}>
            Somente no delivery
          </MenuItem>

          <MenuItem value="INTERNO">Somente vendas internas</MenuItem>
        </TextField>
      </Grid>
      <Grid
        size={{
          xs: 6,
          sm: 2
        }}>
        <TextField
          variant="outlined"
          fullWidth
          label="Ordem"
          name="ordem"
          type="number"
          defaultValue={produto.ordem || 0}
          onChange={(event) => handleChange(event)}
        />
      </Grid>
      <Grid
        size={{
          xs: 6,
          sm: 2
        }}>
        <TextField
          variant="outlined"
          fullWidth
          label="Id Exterior"
          name="codigoExterno"
          value={produto.codigoExterno || ""}
          onChange={(event) => handleChange(event)}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 12
        }}>
        <TextField
          variant="outlined"
          fullWidth
          label={"Descrição"}
          value={produto.descricao || ""}
          name="descricao"
          onChange={(event) => handleChange(event)}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 12
        }}>
        <TextField
          label="Ficha técnica e ingredientes"
          multiline
          fullWidth
          variant="outlined"
          minRows="4"
          name="fichaTecnica"
          value={produto.fichaTecnica || ""}
          onChange={(event) => handleChange(event)}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 12
        }}>
        <TextField
          fullWidth
          variant="outlined"
          label={"Advertências"}
          name="advertencia"
          value={produto.advertencia || ""}
          placeholder="Ex. Contém lactose"
          helperText="Ex: Contém lactose, Bebida alcoólica. Venda somente para maiores de 18 anos"
          onChange={(event) => handleChange(event)}
        />
      </Grid>
    </Grid>
  );
};

export default TabDetails;
